<template>
  <div class="gallery_sm">
    <vueper-slides
      :infinite="false"
      :bullets="false"
      disable-arrows-on-edges
      slide
      :touchable="false"
      fixed-height="100%"
      :initSlide="initSlide"
      :key="initSlide"
    >
      <template #arrow-left>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="41"
          viewBox="0 0 29 41"
          fill="none"
        >
          <path d="M4.5 4L21 20.5L4.5 37" stroke="white" stroke-width="11" />
        </svg>
      </template>

      <template #arrow-right>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="41"
          viewBox="0 0 29 41"
          fill="none"
        >
          <path d="M4.5 4L21 20.5L4.5 37" stroke="white" stroke-width="11" />
        </svg>
      </template>
      <vueper-slide v-for="tier in tiers" :key="tier.id">
        <template #content>
          <div class="tenure">
            <span>{{ tier.title }}</span>
            <span>{{ tier.isleLabSavings }}</span>
            <span>{{ tier.bonusTickets }}</span>
            <span>{{ tier.isleRewardsPoints }}</span>
            <span>{{ tier.ticketExchange }}</span>
            <span>{{ tier.suiteRentalSavings }}</span>
            <span>{{ tier.suiteRentalCredit }}</span>
            <span>{{ tier.playoffPresale }}</span>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import "./GallerySm.scss";

export default {
  name: "GallerySm",
  components: { VueperSlides, VueperSlide },
  props: ["initSlide"],
  data() {
    return {
      tiers: [
        {
          id: 1,
          title: "LEGENDS (5+ Seasons)",
          isleLabSavings: "20%",
          bonusTickets: "8",
          isleRewardsPoints: "Legends Allotment",
          ticketExchange: "Unlimited",
          suiteRentalSavings: "15%",
          suiteRentalCredit: "$2,000",
          playoffPresale: "Early Priority",
        },
        {
          id: 2,
          title: "ALL-STARS (3-4 Seasons)",
          isleLabSavings: "20%",
          bonusTickets: "6",
          isleRewardsPoints: "All-Stars Allotment",
          ticketExchange: "Unlimited",
          suiteRentalSavings: "15%",
          suiteRentalCredit: "$1,500",
          playoffPresale: "Early Priority",
        },
        {
          id: 3,
          title: "VETERANS (2 Seasons)",
          isleLabSavings: "15%",
          bonusTickets: "4",
          isleRewardsPoints: "Veteran Allotment",
          ticketExchange: "5 Game Max",
          suiteRentalSavings: "10%",
          suiteRentalCredit: "$1,000",
          playoffPresale: "Priority Before Public",
        },
        {
          id: 4,
          title: "ROOKIES (1 Season)",
          isleLabSavings: "15%",
          bonusTickets: "2",
          isleRewardsPoints: "Standard Allotment",
          ticketExchange: "3 Game Max",
          suiteRentalSavings: "None",
          suiteRentalCredit: "None",
          playoffPresale: "Priority Before Public",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tenure {
  min-width: 100%;
  display: flex;
  flex-direction: column;

  span {
    color: var(--Blue, #00468b);
    text-align: center;
    font-family: Prompt;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    border: 1px solid #f26924;
    background: #d0d2d3;
    height: 102px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 44px;

    &:first-of-type {
      font-size: 30px;
      font-weight: 900;

      @media screen and (max-width: 768px) {
        font-size: 24px;
      }

      @media screen and (max-width: 500px) {
        font-size: 20px;
      }
    }
  }
}
</style>
